import { Injectable } from '@angular/core';
import { ReportConfig } from './new-reporting-filter';
import { ReportingService } from '../services/reporting.service';

@Injectable({
    providedIn: 'root'
})
export class ReportConfigService {

    constructor(private reportingService: ReportingService) { }

    getReportConfigs(): ReportConfig[] {
        return [
            // ===== Engine Reports (mit groupId, projectId, ioChannels) =====
            {
                id: 'aq',
                label: 'Schaltentscheid',
                reportType: 'Schaltentscheid',
                userRoleAccess: [1,5,9],
                requiredFields: ['utcFrom', 'utcTo'],
                optionalFields: ['samId', 'groupId', 'projectId'], /* ggf. prüfen ob diese mit oder param in required eingebaut werden können */
                availableFor: ['Projekte', 'group', 'RouteStations'],
                serviceMethod: (filter, tz) => this.reportingService.getEngineAQReporting(filter, tz),
                downloadMethod: (filter, tz, fmt) => this.reportingService.downloadEngineAQReport(filter, tz, fmt)
            },
            {
                id: 'mq',
                label: 'Verkehrsanalyse',
                reportType: 'Verkehrsanalyse',
                userRoleAccess: [1,5,9],
                requiredFields: ['utcFrom', 'utcTo'],
                optionalFields: ['samId', 'groupId', 'projectId'],
                availableFor: ['Projekte', 'group', 'RouteStations'],
                serviceMethod: (filter, tz) => this.reportingService.getEngineMQReporting(filter, tz),
                downloadMethod: (filter, tz, fmt) => this.reportingService.downloadEngineMQReport(filter, tz, fmt)
            },

            {
                id: 'di',
                label: 'DI Analyse',
                reportType: 'DI Analyse',
                userRoleAccess: [1,5,9],
                requiredFields: ['utcFrom', 'utcTo'],
                optionalFields: ['samId', 'groupId', 'projectId'],
                availableFor: ['Projekte', 'group', 'RouteStations'],
                serviceMethod: (filter, tz) => this.reportingService.getEngineDIReporting(filter, tz),
                downloadMethod: (filter, tz, fmt) => this.reportingService.downloadEngineDIReport(filter, tz, fmt)
            },

            // ===== Height Event Report =====
            {
                id: 'height',
                label: 'Höhenkontrolle',
                reportType: 'Höhenkontrolle',
                userRoleAccess: [1, 2, 5, 7, 9],
                requiredFields: ['utcFrom', 'utcTo'],
                optionalFields: ['samId', 'groupId', 'projectId'],
                availableFor: ['Projekte', 'group', 'RouteStations'],
                serviceMethod: (filter, tz) => this.reportingService.getHeightEventReporting(filter, tz),
                downloadMethod: (filter, tz, fmt) => this.reportingService.downloadHeightEventReport(filter, tz, fmt)
            },

            // ===== DigitalIO Report (mit ioChannels) =====
            {
                id: 'digitalIO',
                label: 'Digital IO',
                reportType: 'Digital IO',
                userRoleAccess: [1,5, 9],
                requiredFields: ['utcFrom', 'utcTo', 'ioChannels'],
                optionalFields: ['samId', 'groupId', 'projectId'],
                availableFor: ['RouteStations'],
                hasIoChannels: true,
                serviceMethod: (filter, tz) => this.reportingService.getDigitalIOReporting(filter, tz),
                downloadMethod: (filter, tz, fmt) => this.reportingService.downloadDigitalIOReport(filter, tz, fmt)
            },

            // ===== Energy Report =====
            {
                id: 'energy',
                label: 'Energie',
                reportType: 'Energie',
                userRoleAccess: [1,5,9],
                requiredFields: ['utcFrom', 'utcTo'],
                optionalFields: ['samId', 'groupId', 'projectId'],
                availableFor: ['RouteStations'],
                serviceMethod: (filter, tz) => this.reportingService.getEnergyReporting(filter, tz),
                downloadMethod: (filter, tz, fmt) => this.reportingService.getEnergyReportDownload(filter, tz, fmt)
            },
            // ===== Fuel Cell Report =====
            {
                id: 'fuelCell',
                label: 'Brennstoffzelle',
                reportType: 'Brennstoffzelle',
                userRoleAccess: [1,5,9],
                requiredFields: ['utcFrom', 'utcTo'],
                optionalFields: ['samId', 'groupId', 'projectId'],
                availableFor: ['RouteStations'],
                serviceMethod: (filter, tz) => this.reportingService.getFuelCellReporting(filter, tz),
                downloadMethod: (filter, tz, fmt) => this.reportingService.getFuelCellReportDownload(filter, tz, fmt)
            },
            // ===== SAM-only Reports (kein groupId/projectId) =====
            {
                id: 'display',
                label: 'Anzeige',
                reportType: 'Anzeige',
                userRoleAccess: [1,5,9],
                requiredFields: ['utcFrom', 'utcTo', 'samId'], /* double check ob samId wirklich required hier ist und nich optional; siehe rest? */
                optionalFields: [],
                availableFor: ['RouteStations'],
                serviceMethod: (filter, tz) => this.reportingService.getDisplayReporting(filter, tz),
                downloadMethod: (filter, tz, fmt) => this.reportingService.downloadDisplayReport(filter, tz, fmt)
            },
            {
                id: 'brightness',
                label: 'Helligkeit',
                reportType: 'Helligkeit',
                userRoleAccess: [1,5,9],
                requiredFields: ['utcFrom', 'utcTo', 'samId'],
                optionalFields: [],
                availableFor: ['RouteStations'],
                serviceMethod: (filter, tz) => this.reportingService.getBrightnessReporting(filter, tz),
                downloadMethod: (filter, tz, fmt) => this.reportingService.downloadBrightnessReport(filter, tz, fmt)
            },
            // ===== Traffic Data Report =====

            /* Sonderlocke über Config? oder so irgendwie hard reincoden? */
            {
                id: 'trafficData',
                label: 'Verkehrsdaten',
                reportType: 'Verkehrsdaten',
                userRoleAccess: [1,5,9],
                requiredFields: ['utcFrom', 'utcTo', 'samId', 'minutes'], /* 'deChannels'], *//* deChannelsNull */
                optionalFields: [],
                availableFor: ['RouteStations'],
                hasMinutes: true,
                minutesDefault: 60,
                serviceMethod: (filter, tz) => this.reportingService.getTrafficDataReporting(filter, tz),
                downloadMethod: (filter, tz, fmt) => this.reportingService.downloadTrafficDataReport(filter, tz, fmt)
            },
            // ===== Error Message Report =====
            {
                id: 'errorMessages',
                label: 'Fehlermeldungen',
                reportType: 'Fehlermeldungen',
                userRoleAccess: [1,5,9],
                requiredFields: ['utcFrom', 'utcTo'],
                optionalFields: ['samId', 'groupId', 'projectId'], 
                availableFor: ['Projekte', 'group', 'RouteStations'],
                serviceMethod: (filter, tz) => this.reportingService.getErrorMessageReporting(filter, tz),
                downloadMethod: (filter, tz, fmt) => this.reportingService.downloadErrorMessageReport(filter, tz, fmt)
            },
            {
                id: 'weather',
                label: 'Wetterdaten',
                reportType: 'Wetterdaten',
                userRoleAccess: [1,5,9],
                requiredFields: ['utcFrom', 'utcTo'],
                optionalFields: ['samId'], 
                availableFor: ['RouteStations'],
                serviceMethod: (filter, tz) => this.reportingService.getWeatherDataReporting(filter, tz),
                downloadMethod: (filter, tz, fmt) => this.reportingService.downloadWeatherDataReport(filter, tz, fmt)
            }
        ];

    }

    getReportConfig(reportId: string): ReportConfig | undefined {
        return this.getReportConfigs().find(rc => rc.id === reportId);
    }
}
